export const sliderLabel = 'BPM';

export const sliderSx = {
  '& .MuiSlider-thumb': {
    height: 20,
    width: 4,
    borderRadius: 0,
  }
};

export const inputProps = {
  min: 1,
  max: 420,
  style: {
    width: 29,
    textAlign: 'center',
  }
};